import EvalSelectDepartmenttree from './src/main';

/* istanbul ignore next */
EvalSelectDepartmenttree.install = function(Vue) {
  Vue.component(EvalSelectDepartmenttree.name, EvalSelectDepartmenttree);
};

export default EvalSelectDepartmenttree;
